export const initialBrokerFormValues = {
  internalText: '',
  borrowerInternalText: '',
  priorToType: '',
  taskTypeIds: [],
};

export const initialInternalFormValues = {
  internalText: '',
  borrowerInternalText: '',
  priorToType: '',
  slaGroupId: '',
  taskTypeIds: [],
};

export const NEW_FORM_DIALOG_HEADER = 'Create new loan specific form';

export const TASK_NAME_REPLACE_KEY = 'name';

export const TASK_NAME_REPLACE_WITH_KEY = 'value';
